module.exports = __webpack_public_path__ + "img/Box_2via.16d73325.png";